import { buildMockSectionSummaries } from './sectionSummaryLookup.mock';
import { SectionSummary } from './SectionSummary.types';

// TODO DREGAB-29796: replace with the real summary query for the patient once the backend exposes it
export const fetchSectionSummaries = (patientId: number): SectionSummary[] => buildMockSectionSummaries(patientId);
